import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Delete';
import Select from '@material-ui/core/Select';
import account_remove from '../../assets/icons/account-remove.png'
import editPermision from '../../assets/icons/editPermision.png'
import { Button, Typography } from '@material-ui/core';
import { useStyles } from './MembersStyle';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#5B6773',
    color: '#ffffff',
    border: 'none',
    outline: 'none',
    height: 52,
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 16,

  },
  body: {
    height: 52,
    color: '#5B6773',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 16,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#F4F6F8',
    },
  },
}))(TableRow);

function createData(name) {
  return { name };
}

const rows = [
  createData('1'),
  createData('2'),
];
export default function Event() {
  const classes = useStyles();
  const [age, setAge] = React.useState('');
  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const updateSize = () =>
    setSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  useEffect(() => (window.onresize = updateSize), []);
  return (
    <div
    style={{ width: size.width < 960 ? "100%" : size.width - 330 }}
    >
      <div>
        <Typography
          variant="h6"
          component="div"
          noWrap={true}
          className={classes.eventText}
        >
          Project member
        </Typography>

        <div className={classes.projectContainer}>
          <p className={classes.eventText} style={{ fontSize: 20 }}>Invite a new project member</p>
          <p className={classes.project_PTag} style={{ marginTop: 20 }}>
            Email address of the user to invite
          </p>
          <div className={classes.IconAndInputField}>
            <input className={classes.Input} type='text' placeholder='Enter Your Email' />
          </div>
          <p className={classes.project_PTag} style={{ marginTop: 20, marginBottom: 10 }}>
            User role
          </p>
          <Select
            className={classes.projectSelect}
            disableUnderline
            native
            value={age}
            onChange={handleChange}
            inputProps={{
              name: 'age',
              id: 'age-native-simple',
            }}
            classes={{ root: classes.selectSelected }}
          >
            <option aria-label="None" value="" />
            <option value={10}>admin</option>
          </Select>
          <div className={classes.marginDiv} />
          <p className={classes.project_PTag}><b>Admin role</b> Seamlessly actualize cross-media e-markets and 24/365 convergence. Interactively impact cutting-edge Competently deploy front-end quality vectors for clicks-and-mortar leadership skills.  </p>
          <div className={classes.marginDiv} />
          <p className={classes.project_PTag}><b>Operator role</b> Seamlessly actualize cross-media e-markets and 24/365 convergence.Interactively impact cutting-edge Competently deploy front-end quality vectors for clicks-and-mortar leadership skills.  </p>
          <div className={classes.marginDiv} />
          <p className={classes.project_PTag}><b>Read-only role</b> Seamlessly actualize cross-media e-markets and 24/365 convergence.Interactively impact cutting-edge Competently deploy front-end quality vectors for clicks-and-mortar leadership skills.  </p>
          <div className={classes.marginDiv} />
          <div className={classes.projectBtnContainer}>
            <Button variant="outlined" disableRipple={true}
              className={classes.projectBtn}
            >
              Send invitaion
            </Button>
          </div>
        </div>
      </div>

      <Typography
        variant="h6"
        component="div"
        noWrap={true}
        className={classes.eventText}
      >
        Members
      </Typography>
      <div className={classes.eventContainer}>
        <TableContainer component={Paper} style={{ borderRadius: 12 }}>
          <Table className={classes.table} size="medium" aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>User Email</StyledTableCell>
                <StyledTableCell >Team</StyledTableCell>
                <StyledTableCell >Authentication</StyledTableCell>
                <StyledTableCell >Member type</StyledTableCell>
                <StyledTableCell >Billing Contact</StyledTableCell>
                <StyledTableCell >Created</StyledTableCell>
                <StyledTableCell ></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell component="th" scope="row">
                    kafka45@securityscorecard.io
                  </StyledTableCell>
                  <StyledTableCell >{'Account Owners'}</StyledTableCell>
                  <StyledTableCell >{'Password'}</StyledTableCell>
                  <StyledTableCell >
                    <Select
                      disableUnderline
                      native
                      value={age}
                      onChange={handleChange}
                      inputProps={{
                        name: 'age',
                        id: 'age-native-simple',
                      }}
                      classes={{ root: classes.select }}
                    >
                      <option aria-label="None" value="" />
                      <option value={10}>admin</option>
                    </Select>
                  </StyledTableCell>
                  <StyledTableCell >{'No'}</StyledTableCell>
                  <StyledTableCell >{'3 days'}</StyledTableCell>
                  <StyledTableCell align='center'>
                    <Button variant="outlined" disableRipple={true}
                      startIcon={<img src={account_remove} alt='img' width={18} height={18} />}
                      className={classes.customBtn}
                    >
                      Remove User
                    </Button>

                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* Teams Section */}
      <div >
        <div className={classes.teamContainer}>
          <Typography
            variant="h6"
            component="div"
            noWrap={true}
            className={classes.eventText}
          >
            Teams
          </Typography>

          <div className={classes.teamBtnContainer}>
            <Button
              variant="contained"
              className={classes.teamBtn}
            >
              Add Existing Team
            </Button>
            <Button
              variant="contained"
              className={classes.teamBtn}
            >
              Create New Team
            </Button>
          </div>
        </div>
        <TableContainer component={Paper} className={classes.eventContainer} style={{ borderRadius: 12 }}>
          <Table className={classes.table} size="medium" aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Team Name</StyledTableCell>
                <StyledTableCell >Permission Level</StyledTableCell>
                <StyledTableCell ></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell component="th" scope="row">
                    {'Account Owners'}
                  </StyledTableCell>
                  <StyledTableCell >{'admin'}</StyledTableCell>
                  <StyledTableCell align='right'>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <Button variant="outlined" disableRipple={true}
                        startIcon={<img src={editPermision} alt='img' width={18} height={18} />}
                        className={classes.teamTableBtn}
                      >
                        Remove User
                      </Button>
                      <Button variant="outlined" disableRipple={true}
                        startIcon={<DeleteIcon style={{ color: '#824ED2', fontSize: '21px' }} />}
                        className={classes.teamTableBtn}
                      >
                        Remove User
                      </Button>
                    </div>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

      </div>

    </div>

  );
}
